import controller from './categories-input-filter.controller';
import templateBase from './templates/categories-input-filter-base.view.html';

let CategoriesInputFilterComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    //let response = SessionService.get('components');

    /*if (response.BY_FAVORITES.component == 'template_t1') {
        return templateT1;
    } else {*/
    return templateBase;
    //}
}

export default CategoriesInputFilterComponent;



// WEBPACK FOOTER //
// ./www/components/catalog/categories-filter/categories-input-filter/categories-input-filter.component.js